<ion-item color="{{ color }}">
    <ion-grid>
        <ion-row>
            <ion-badge color="{{ ColorClass.Secondary }}" *ngIf="label !== undefined">{{
                label
            }}</ion-badge>
        </ion-row>
        <ion-row>
            <ion-col size="3" class="ion-align-self-start">
                <img [src]="orderReplacementItem.itemThumbnailSrc" />
            </ion-col>
            <ion-col size="9" class="ion-align-self-start">
                <ion-label class="ion-text-wrap">
                    <ion-row>
                        <ion-col>
                            <h2>{{ orderReplacementItem.itemName }}</h2>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="8.5">
                            <ion-label>
                                <strong>{{ 'common.sku' | translate }}:</strong>
                                {{ orderReplacementItem.sku || '-' }}
                            </ion-label>
                            <ion-label>
                                <strong>{{ 'common.price' | translate }}:</strong>
                                {{ orderReplacementItem.price | priceround }}
                                {{ 'common.currency' | translate }}
                            </ion-label>
                        </ion-col>
                        <ion-col size="3.5">
                            <app-order-item-state
                                [orderItemState]="orderItemState"
                            ></app-order-item-state>
                        </ion-col>
                    </ion-row>
                </ion-label>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col class="ion-align-self-start">
                <ion-label>
                    <p class="ion-no-margin">
                        <strong>{{ 'collecting.approved' | translate }}</strong>
                        {{ quantity | decimal }}
                    </p>
                </ion-label>
            </ion-col>
            <ion-col class="ion-align-self-end">
                <ion-label>
                    <p class="ion-no-margin">
                        <strong>{{ 'collecting.collected' | translate }}</strong>
                        {{ orderReplacementItem.collectedQuantity | decimal }}
                    </p>
                </ion-label>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="orderReplacementItem.orderReplacementItemDepositProductList">
            <ion-col
                *ngFor="
                    let orderReplacementItemDepositProduct of orderReplacementItem.orderReplacementItemDepositProductList
                "
                class="border my-1"
            >
                <strong
                    >{{
                        'collecting.optional-deposit-quantity-title' | translate
                    }}:</strong
                ><br />
                {{ orderReplacementItemDepositProduct.depositUnitTypeName }}
                {{ orderReplacementItemDepositProduct.price | priceround }}
                {{ 'common.currency' | translate }}
                {{ orderReplacementItemDepositProduct.unitName }}
                <br />
                <div>
                    <strong>{{ 'collecting.quantity' | translate }}</strong
                    ><br />
                    {{ orderReplacementItemDepositProduct.unitValue }}
                    {{ 'collecting.piece(s)' | translate }}*
                    {{ orderReplacementItemDepositProduct.price | priceround }}
                    {{ 'common.currency' | translate }} =
                    <strong>
                        {{
                            orderReplacementItemDepositProduct.unitValue *
                                orderReplacementItemDepositProduct.price | priceround
                        }}
                        {{ 'common.currency' | translate }}</strong
                    >
                </div>

                <div *ngIf="orderReplacementItemDepositProduct.collectedQuantity">
                    <strong>{{ 'collecting.already-added-to-cart' | translate }}</strong
                    ><br />
                    {{ orderReplacementItemDepositProduct.collectedQuantity }}
                    {{ 'collecting.piece(s)' | translate }}*
                    {{ orderReplacementItemDepositProduct.price | priceround }}
                    {{ 'common.currency' | translate }} =
                    <strong>
                        <u
                            >+
                            {{
                                orderReplacementItemDepositProduct.collectedQuantity *
                                    orderReplacementItemDepositProduct.price | priceround
                            }}
                            {{ 'common.currency' | translate }}</u
                        ></strong
                    >
                </div>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-item>
